import { EventIndexEntriesQueryVariables } from '@/__generated__/graphql';
import { EVENT_INDEX_QUERY } from '@/gql/queries/eventIndexQueries.gql';
import { useQuery } from '@apollo/client';
import { makeNonNullableArray } from '@liquorice/utils';

export const useShortlist = (variables: EventIndexEntriesQueryVariables) => {
  const { data: rawData, loading, error } = useQuery(EVENT_INDEX_QUERY, { variables });

  const data = makeNonNullableArray(rawData?.eventEntries);

  return { data, loading, error };
};
